import React from "react";
import { Navigate } from "react-router-dom";
import { getDefaultWhatsAppPath } from "../../utils/whatsappPermissions";

export default function WhatsAppRootRedirect() {
  const path = getDefaultWhatsAppPath();
  if (path) {
    return <Navigate to={path} replace />;
  }
  return <Navigate to="/permissionrestricted" replace />;
}
